<template>
  <div class="knowledge-study-level" v-if="overviewData.length">
    <div class="level-title">
      <div class="level-title__left">
        <p class="left-line"/>
        <p class="left-text">
          <span class="text-bg">学业等级分布</span>
        </p>
      </div>
    </div>
    <div id="stuChart" class="knowledge-chart"/>
  </div>
</template>

<script>
export default {
  name: 'KnowledgeStudyLevel',
  props: {
    overviewData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      chart: '',
    };
  },
  watch: {
    overviewData(v) {
      this.$nextTick(() => {
        this.initChart(v);
      });
    },
  },
  methods: {
    initChart(data) {
      this.chart = this.$echarts.init(document.getElementById('stuChart'));
      const chartName = data.map((item) => item.name);
      const CHART_VAL_A = data.map((item) => (Number(item.score_data.A) === 0 ? '' : item.score_data.A));
      const CHART_VAL_B = data.map((item) => (Number(item.score_data.B) === 0 ? '' : item.score_data.B));
      const CHART_VAL_C = data.map((item) => (Number(item.score_data.C) === 0 ? '' : item.score_data.C));
      const CHART_VAL_D = data.map((item) => (Number(item.score_data.D) === 0 ? '' : item.score_data.D));
      const CHART_VAL_E = data.map((item) => (Number(item.score_data.E) === 0 ? '' : item.score_data.E));
      // 使用刚指定的配置项和数据显示图表。
      const option = {
        color: ['#FB602D', '#FF9F00', '#FFCC0C', '#0089FF', '#00B853'],
        grid: {
          left: '50',
          right: '120',
          bottom: '3%',
          containLabel: true,
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'shadow', // 默认为直线，可选为：'line' | 'shadow'
          },
          formatter(params) {
            // 暂时不要header
            // const headerName = params.length && `<div style="text-align:center;">
            // ${params[0].name}</div>`;
            const customList = params.length && params.map((item) => {
              const dotColor = `<span style="display:inline-block;margin-right:5px;border-radius:
            10px;width:9px;height:9px;background-color:${item.color}"></span>`;
              return `${dotColor + item.seriesName}:${item.value || 0}%</br>`;
            });
            // return headerName + customList.join('');
            return customList.join('');
          },
        },
        legend: {
          icon: 'circle',
          itemGap: 20, // 设置间距
          data: ['未掌握(0-20%)', '掌握较弱(21-40%)', '掌握一般(41-60%)', '掌握较好(61-80%)', '掌握熟练(81-100%)'],
        },
        xAxis: {
          type: 'category',
          axisLabel: { interval: 0, rotate: 30 },
          data: chartName,
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            show: true,
            interval: 'auto',
            formatter: '{value} %',
          },
          show: true,
          max: 100,
          min: 0,
        },
        series: [
          {
            name: '未掌握(0-20%)',
            type: 'bar',
            stack: 'total',
            barWidth: '22%',
            label: {
              normal: {
                show: true,
                position: 'inside',
                formatter: '{c}%',
              },
            },
            data: CHART_VAL_A,
          },
          {
            name: '掌握较弱(21-40%)',
            type: 'bar',
            stack: 'total',
            barWidth: '22%',
            label: {
              normal: {
                show: true,
                position: 'inside',
                formatter: '{c}%',
              },
            },
            data: CHART_VAL_B,
          },
          {
            name: '掌握一般(41-60%)',
            type: 'bar',
            stack: 'total',
            barWidth: '22%',
            label: {
              normal: {
                show: true,
                position: 'inside',
                formatter: '{c}%',
              },
            },
            data: CHART_VAL_C,
          },
          {
            name: '掌握较好(61-80%)',
            type: 'bar',
            stack: 'total',
            barWidth: '22%',
            label: {
              normal: {
                show: true,
                position: 'inside',
                formatter: '{c}%',
              },
            },
            data: CHART_VAL_D,
          },
          {
            name: '掌握熟练(81-100%)',
            type: 'bar',
            stack: 'total',
            barWidth: '22%',
            label: {
              normal: {
                show: true,
                position: 'inside',
                formatter: '{c}%',
              },
            },
            data: CHART_VAL_E,
          },
        ],
      };
      this.chart.setOption(option);
    },
  },
  mounted() {

  },
};
</script>

<style lang="scss" scoped>
.knowledge-study-level{
  // margin-top:-40px;
  padding:20px;
  .level-title{
    &__left{
      display: flex;
      align-items: center;
      .left-line{
        margin:19px 0 20px 0;
        display: block;
        width: 3px;
        height: 16px;
        background: #1890FF;
        border-radius: 3px;
        margin-right: 8px;
      }
      .left-text{
        font-size: 18px;
        height: 25px;
        font-family: 'PingFangSC-Medium', 'PingFang SC';
        font-weight: 500;
        color: #000000;
        line-height: 25px;
        position: relative;
        &:after{
          content:'';
          position: absolute;
          width:100%;
          height:50%;
          left:0;
          bottom:3px;
          background:rgba(230, 162, 60, 0.2);
          border-radius: 16px;
        }
        .text-bg{
          position: relative;
          z-index: 2;
        }
      }
    }
  }
  .knowledge-chart{
    width: 100%;
    height:600px;
  }
}
</style>
